import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, Menu, X } from "lucide-react";
import logoBlack from "../assets/Adastralogo.png";
import { useCart } from "../context/CartContext";
import CartDrawer from "./CartDrawer";
import { motion, AnimatePresence } from "framer-motion";
import { useEffect } from "react";

export default function Navbar() {
  const { totalItems } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);
  const { cartOpen, openCart, closeCart } = useCart();

useEffect(() => {
  document.body.style.overflow = menuOpen ? "hidden" : "auto";

  return () => {
    document.body.style.overflow = "auto";
  };
}, [menuOpen]);

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white border-b border-gray-200 shadow-sm">
     {/* Banner 2 — Black Weekend Sale */}
    {/* <section
      className="bg-gradient-to-r from-[#000000] to-[#1a1a1a] text-white
                py-1.5
                text-[10px] sm:text-sm md:text-base
                font-semibold tracking-wide text-center drop-shadow-sm"
    >
      🛒 Black Weekend Sale · Solo por este fin de semana aplica el código <span className="font-bold">BLACK</span> al finalizar tu compra para un <span className="font-bold">20% de descuento adicional</span>
    </section> */}
    {/* Banner 1 — Envíos y garantía */}
    <section
      className="bg-gradient-to-r from-[#d24e1e] to-[#e85c2d] text-white
                border-b border-gray-100 py-1.5
                text-[10px] sm:text-sm md:text-base
                font-semibold tracking-wide text-center drop-shadow-sm"
    >
      🚚 Envío GRATIS a partir del segundo producto en el carrito · 💰 Garantía de satisfacción total
    </section>

   


      {/* 🔹 Contenedor principal */}
      <div className="max-w-7xl mx-auto px-4 py-2 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-3 group">
          <img
            src={logoBlack}
            alt="AdAstra"
            className="h-10 sm:h-12 object-contain transition-transform duration-200 group-hover:scale-105"
          />
          <div className="flex flex-col leading-tight">
            <span className="text-lg sm:text-xl font-semibold text-gray-900 tracking-wide font-serif">
              AdAstra
            </span>
            <span className="text-[10px] sm:text-xs text-gray-500 italic font-light">
              Suplementos Naturales Premium CR
            </span>
          </div>
        </Link>

        {/* Menú principal (desktop) */}
        <nav className="hidden md:flex space-x-8 text-sm font-semibold uppercase tracking-wide text-gray-800">
          <Link to="/" className="hover:text-gray-500 transition">Inicio</Link>
          <Link
            to="/#products"
            onClick={() => {
              setTimeout(() => {
                const el = document.getElementById("products");

                if (!el) return;

                const y =
                  el.getBoundingClientRect().top + window.pageYOffset - 80; // 80 = altura del header

                window.scrollTo({
                  top: y,
                  behavior: "smooth",
                });
              }, 100);
            }}
            className="hover:text-gray-500 transition"
          >
            Productos
          </Link>
          <Link to="/about" className="hover:text-gray-500 transition">Nosotros</Link>
        </nav>

        {/* 🔹 Iconos (carrito + menú móvil) */}
        <div className="flex items-center gap-4">
          {/* Carrito siempre visible */}
          <button onClick={openCart} className="relative hover:scale-105 transition">
            <ShoppingCart size={24} className="text-gray-900" />
            {totalItems > 0 && (
              <span className="absolute -top-2 -right-2 bg-[#e45f5a] text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                {totalItems}
              </span>
            )}
          </button>

          {/* Botón menú móvil */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden text-gray-800 hover:text-black transition"
          >
            {menuOpen ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {/* 🔹 Menú desplegable móvil */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{
              height: "auto",
              opacity: 1,
              pointerEvents: "auto",
            }}
            exit={{
              height: 0,
              opacity: 0,
              pointerEvents: "none",
            }}
            transition={{ duration: 0.25 }}
            className="md:hidden bg-white border-t border-gray-200 shadow-inner overflow-hidden"
          >

            <div className="flex flex-col items-center py-4 space-y-4 text-sm font-semibold uppercase text-gray-800">
              <Link
                to="/"
                onClick={() => setMenuOpen(false)}
                className="hover:text-[#e45f5a] transition"
              >
                Inicio
              </Link>
              <Link
              to="/#products"
              onClick={() => {
                
                // 👇 LIBERAR SCROLL ANTES DE HACER NADA
                document.body.style.overflow = "auto";
                document.body.style.position = "static";

                // (si usas estado de menú)
                setMenuOpen(false);

                setTimeout(() => {
                  const el = document.getElementById("products");
                  if (!el) return;

                  const y =
                    el.getBoundingClientRect().top +
                    window.pageYOffset -
                    80;

                  window.scrollTo({
                    top: y,
                    behavior: "smooth",
                  });
                }, 150);
              }}
              className="hover:text-gray-500 transition"
            >
              Productos
            </Link>
              <Link
                to="/about"
                onClick={() => setMenuOpen(false)}
                className="hover:text-[#e45f5a] transition"
              >
                Nosotros
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* 🔹 Drawer del carrito */}
     <CartDrawer isOpen={cartOpen} onClose={closeCart} />
    </header>
  );
}
